// extracted by mini-css-extract-plugin
module.exports =  {"root":"TaJH1JyKkoqObr0UJmQ1","input":"bdUpnWg42XuK7mEAa7U5"};